import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectStripe, PaymentRequestButtonElement } from 'react-stripe-elements';
import { loadTreatment } from '@surfline/web-common/dist/features/redux';
import { ENABLE_DIGITAL_WALLET } from '../../common/utils/treatments';

class PaymentRequestGift extends Component {
  constructor(props) {
    super(props);
    this.state = {
      digitalWallet: false,
      paymentRequest: null,
      enableDigitalWallet: this.props.doLoadTreatment(ENABLE_DIGITAL_WALLET) === 'on',
    };
  }

  async componentDidMount() {
    await this.setupPaymentRequest();
  }

  async setupPaymentRequest() {
    const {
      paymentHandler,
      selectedProduct
    } = this.props;
    const { description: label, price: amount } = selectedProduct;
    const paymentRequestObject = {
      country: 'US',
      currency: 'usd',
      total: {
        label,
        amount,
      },
    };
    const paymentRequest = this.props.stripe.paymentRequest(paymentRequestObject);
    const digitalWallet = await paymentRequest.canMakePayment();
    this.setState({ digitalWallet, paymentRequest });
    paymentRequest.on('token', async (ev) => {
      try {
        await paymentHandler(ev.token);
        ev.complete('success');
      } catch (err) {
        ev.complete('fail');
      }
    });
  }

  render() {
    const { paymentRequest, digitalWallet, enableDigitalWallet } = this.state;
    return (
      enableDigitalWallet && digitalWallet ?
        <div>
          <div className="checkout-form__container__digital_wallet__section" />
          <PaymentRequestButtonElement
            paymentRequest={paymentRequest}
            className="checkout-form__container__digital_wallet__button"
            style={{
              paymentRequestButton: {
                height: '48px',
              },
            }}
          />
        </div>
        : null
    );
  }
}

export default connect(null, dispatch => ({
  doLoadTreatment: treatment => dispatch(loadTreatment(treatment)),
}))(injectStripe(PaymentRequestGift));
